import baseRoute from '../baseRoute';

export type * from './viewModel';

type RouteDefinition = `${typeof baseRoute}/jobsForTemplate/${number | ':templateId'}`;

export const ROUTE: RouteDefinition = `${baseRoute}/jobsForTemplate/:templateId`;

export const URL = (templateId: number): RouteDefinition => `${baseRoute}/jobsForTemplate/${templateId}`;
